import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Container, Table, Button } from "react-bootstrap";
import { get } from "../../services/Services";
import { useAuthProvider } from "../../customHooks/authContext";
import "bootstrap/dist/css/bootstrap.min.css";
import CoursesForm from "./CoursesForm";
import CoursesFormEdit from "./CoursesFormEdit";

const Courses = () => {
  const location = useLocation();
  const { configId, eventRegistrationId } = location.state || {};
  const { school } = useAuthProvider();
  const schoolId = school?.id;
  const [registrationVisible, setRegistrationVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedCourseDetails, setSelectedCourseDetails] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [disabledCreateButton, setDisabledCreateButton] = useState({});
  const [disabledEditButton, setDisabledEditButton] = useState({});

  const [coursesData, setCoursesData] = useState(null);
  const [ fetchCourseData, setFetchCourseData ] = useState(false)
 
  useEffect(() => {
    if (schoolId) {
      get(`/api/academy/events/${configId}/courses?event_registration_id=${eventRegistrationId}&page=0&size=11`)
        .then((response) => setCoursesData(response.data), setFetchCourseData(false))
        .catch((error) => console.error("Error loading courses:", error));
    }
  }, [schoolId, configId, eventRegistrationId, fetchCourseData]);


  useEffect(() => {
    if (selectedCourse?.courseRegistrationId) {
       get(`/api/academy/events/registration/${eventRegistrationId}/courses/${selectedCourse.courseRegistrationId}`)
        .then((response) => {
          setSelectedCourseDetails(response.data) })
        .catch((error) => console.error("Error loading course details:", error));
    }
  }, [selectedCourse, eventRegistrationId]);


  useEffect(() => {
    const newDisabledCreate = {};
    const newDisabledEdit = {};
  
    coursesData?.content?.forEach(course => {
  
      newDisabledCreate[course.id] = !!course.courseRegistrationId;
      newDisabledEdit[course.id] = !course.courseRegistrationId;
    });
  
    setDisabledCreateButton(newDisabledCreate);
    setDisabledEditButton(newDisabledEdit);
  }, [coursesData]);

  const handleInscriptionClick = (course) => {
    setSelectedCourse(course);
    setSelectedMembers([]);
    setRegistrationVisible(true);
    setEditVisible(false);
  };

  const handleEditInscriptionClick = (course) => {
    setSelectedCourse(course);
    setEditVisible(true);
    setRegistrationVisible(false);
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center fw-bold text-primary">Seminarios y Congresos </h2>

      <Table striped bordered hover className="text-center">
        <thead className="table-primary">
          <tr>
            <th>Seminario/Congreso</th>
            <th>Nombre</th>
            <th>Profesor/a</th>
            <th>Nivel</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {coursesData?.content?.map((curso) => (
            <tr key={curso.id}>
              <td>{curso.type.name}</td>
              <td>{curso.name}</td>
              <td>{curso.teacher}</td>
              <td>{curso.level.name}</td>
              <td>
                <Button variant="primary" size="sm" onClick={() => handleInscriptionClick(curso)} disabled={ disabledCreateButton[curso.id] }>
                  Inscripción
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => handleEditInscriptionClick(curso)}
                  disabled={ disabledEditButton[curso.id] }
                  style={{ marginLeft: "8px" }}
                >
                  Agregar - Eliminar Participantes
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {registrationVisible && selectedCourse && (
        <CoursesForm
          configId={configId}
          courseId={selectedCourse.id}
          onHide={() => setRegistrationVisible(false)}
          eventRegistrationId={eventRegistrationId}
          fetchCourseData = {fetchCourseData}
          setFetchCourseData = {setFetchCourseData}
        />
      )}

      {editVisible && selectedCourse && (
        <CoursesFormEdit
          configId={configId}
          courseId={selectedCourse.id}
          onHide={() => setEditVisible(false)}
          eventRegistrationId={eventRegistrationId}
          courseDetails={selectedCourseDetails}
          fetchCourseData = {fetchCourseData}
          setFetchCourseData = {setFetchCourseData}
        />
      )}
    </Container>
  );
};

export default Courses;
